//src/components/ModalAtualizacaoPerfil.js
import React from "react";
import { ShieldCheck } from "lucide-react";
import "./ModalAtualizacaoPerfil.css";

function ModalAtualizacaoPerfil({ onAtualizar }) {
  return (
    <div className="modalAtualizacao-overlay">
      <div className="modalAtualizacao-box">
        <div className="modalAtualizacao-icon">
          <ShieldCheck size={42} />
        </div>

        <h2>Atualização obrigatória de cadastro</h2>

        <p>
          O TikPontos está passando por uma atualização de segurança e
          identificação dos participantes.
        </p>

        <div className="modalAtualizacao-info">
          <p>• Os cadastros passam a ser vinculados ao CPF/CNPJ do titular.</p>
          <p>• Os pontos são pessoais e intransferíveis.</p>
          <p>• Contas PJ pertencem à empresa cadastrada.</p>
          <p>
            • Em caso de desligamento informado pela empresa, a conta poderá ser
            inativada.
          </p>
        </div>

        <button type="button" onClick={onAtualizar}>
          Atualizar meu cadastro
        </button>
      </div>
    </div>
  );
}

export default ModalAtualizacaoPerfil;